var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeakerOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1857 8.57183C22.8545 8.35384 22.5081 8.16878 22.149 8.02001C21.5719 7.78089 21 8.25504 21 8.87976V9.0062C21 9.44491 21.2916 9.823 21.6808 10.0254C21.6921 10.0312 21.7033 10.0371 21.7145 10.043L23.1857 8.57183ZM25.823 11.5914L24.3306 13.0837C24.7476 14.0715 25 15.2484 25 16.5879C25 19.9106 23.4473 22.2323 21.6808 23.1505C21.2916 23.3529 21 23.731 21 24.1697V24.2961C21 24.9208 21.5719 25.395 22.149 25.1559C24.9636 23.9898 27 20.5946 27 16.5879C27 14.7393 26.5665 13.0208 25.823 11.5914ZM21 16.4144L22.7073 14.707C22.896 15.2877 23 15.9226 23 16.5879C23 17.6551 22.7326 18.6441 22.2769 19.456C21.8775 20.1677 21 19.7779 21 18.9619V16.4144ZM19 12.7575V8.002C19 7.1111 17.9229 6.66493 17.2929 7.2949L13.2929 11.2949C13.1054 11.4824 12.851 11.5878 12.5858 11.5878H10C8.34315 11.5878 7 12.9309 7 14.5878V18.5878C7 20.2446 8.34315 21.5878 10 21.5878H10.1697L19 12.7575ZM14.4133 23.0011L19 18.4144V25.1736C19 26.0645 17.9229 26.5106 17.2929 25.8807L14.4133 23.0011Z",
    fill: "#0071FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2071 7.29289C27.5976 7.68342 27.5976 8.31658 27.2071 8.70711L9.20711 26.7071C8.81658 27.0976 8.18342 27.0976 7.79289 26.7071C7.40237 26.3166 7.40237 25.6834 7.79289 25.2929L25.7929 7.29289C26.1834 6.90237 26.8166 6.90237 27.2071 7.29289Z",
    fill: "#0071FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerOff);
export default __webpack_public_path__ + "static/media/speakerOff.251eb304d9d5fa223c779f110f33211f.svg";
export { ForwardRef as ReactComponent };